import { render } from "./viewKpi.vue?vue&type=template&id=2b8c0134&scoped=true&ts=true"
import script from "./viewKpi.vue?vue&type=script&lang=ts"
export * from "./viewKpi.vue?vue&type=script&lang=ts"

import "./viewKpi.vue?vue&type=style&index=0&id=2b8c0134&scoped=true&lang=css"
import "./viewKpi.vue?vue&type=style&index=1&id=2b8c0134&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8c0134"]])

export default __exports__